import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/Banner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/BannerTwo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/CategorySection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/ChooseUs.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/DownloadApp.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/Industries.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/MarketNews.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/OfferBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/Partner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/People.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/app/home/component/Services.jsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/src/assets/home/ai-stars.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/src/assets/home/cart-large.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/src/assets/home/satelight.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/components/ReadyToOrder.jsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/src/styles/css/home.scss");
